import(/* webpackMode: "eager", webpackExports: ["LayoutContainer"] */ "/vercel/path0/src/components/layout/index.tsx");
